import {
  Card,
  CardBody,
  Col,
  Row,
  InputGroup,
  Input,
  Label,
  FormGroup,
  InputGroupText,
} from "reactstrap";
import { dynamicAPIImage } from "../../../../Utils";
import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { H6, Image, P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Link } from "react-router-dom";
import { Camera } from "react-feather";

// Services
import {
  employeeService,
  VIEW_EMPLOYEE_PROFILE_QUERY_KEY,
} from "../../../../Services/employeeService";

// Modals
import UpdateEmpDetailsModal from "../../../UiKits/Modal/Employee/UpdateEmploymentDetails";

// Types
import { ViewEmployeeProfile } from "../../../../Types/Employee/EmployeeModel";
import { CRUDPermissions } from "../../../../Types/Common/Access";

interface EmployeeProfileProps {
  EmpNo: string;
  isAdmin: boolean;
  access: CRUDPermissions;
}

const PositionDetails: React.FC<EmployeeProfileProps> = ({
  EmpNo,
  isAdmin,
  access,
}) => {
  const [profileData, setProfileData] = useState<ViewEmployeeProfile | null>(
    null,
  );

  // Get Employee Profile
  const { data: empProfileResponse, isLoading: empProfileIsFetching } =
    useQuery({
      queryKey: [VIEW_EMPLOYEE_PROFILE_QUERY_KEY, EmpNo],
      queryFn: () => employeeService.viewEmployeeProfileByEmpno(EmpNo),
      enabled: !!EmpNo,
    });

  useEffect(() => {
    if (empProfileResponse?.data) {
      setProfileData(empProfileResponse?.data);
    }
  }, [empProfileResponse?.data]);

  return (
    <Card className="card-absolute">
      <CommonCardHeader
        headClass="bg-primary"
        tagClass="txt-light"
        icon={<i className="icofont icofont-briefcase-alt-1 me-1"></i>}
        title={"Employment Details"}
      />
      <CardBody>
        <Row>
          <Col sm="12">
            <FormGroup>
              <Label>Job Title</Label>
              <InputGroup>
                <InputGroupText>
                  <i className="icofont icofont-briefcase-alt-1 txt-primary"></i>
                </InputGroupText>
                <Input
                  className="bg-white text-color-light"
                  disabled
                  value={
                    empProfileIsFetching
                      ? "Loading..."
                      : profileData?.job_title?.toUpperCase() ||
                        "* No Data Found *"
                  }
                />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col sm="12">
            <FormGroup>
              <Label>Job Level / Rank</Label>
              <InputGroup>
                <InputGroupText>
                  <i className="icofont icofont-chart-histogram txt-primary"></i>
                </InputGroupText>
                <Input
                  className="bg-white text-color-light"
                  disabled
                  value={
                    empProfileIsFetching
                      ? "Loading..."
                      : profileData?.job_level_label?.toUpperCase() ||
                        "* No Data Found *"
                  }
                />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col sm="6">
            <FormGroup>
              <Label>Basic Salary</Label>
              <InputGroup>
                <InputGroupText>
                  <i className="icofont icofont-cur-peso txt-primary"></i>
                </InputGroupText>
                <Input
                  className="bg-white text-color-light text-end"
                  disabled
                  value={
                    empProfileIsFetching
                      ? "Loading..."
                      : profileData?.basic_salary != null
                        ? Number(profileData.basic_salary).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )
                        : "* No Data Found *"
                  }
                />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col sm="6">
            <FormGroup>
              <Label>Salary Type</Label>
              <InputGroup>
                <InputGroupText>
                  <i className="icofont icofont-wallet txt-primary"></i>
                </InputGroupText>
                <Input
                  className="bg-white text-color-light"
                  disabled
                  value={
                    empProfileIsFetching
                      ? "Loading..."
                      : profileData?.salary_type
                        ? ({
                            MNTH: "MONTHLY",
                            SMNT: "SEMI-MONTHLY",
                            WEEK: "WEEKLY",
                            DAYS: "DAILY",
                            HOUR: "HOURLY",
                          }[profileData.salary_type] ??
                          profileData.salary_type.toUpperCase())
                        : "* No Data Found *"
                  }
                />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col sm="12">
            <FormGroup>
              <Label>Pay Frequency</Label>
              <InputGroup>
                <InputGroupText>
                  <i className="icofont icofont-ui-calendar txt-primary"></i>
                </InputGroupText>
                <Input
                  className="bg-white text-color-light"
                  disabled
                  value={
                    empProfileIsFetching
                      ? "Loading..."
                      : profileData?.pay_frequency
                        ? ({
                            MNTH: "MONTHLY",
                            SMNT: "SEMI-MONTHLY",
                            WEEK: "WEEKLY",
                            DAYS: "DAILY",
                            HOUR: "HOURLY",
                          }[profileData.pay_frequency] ??
                          profileData.pay_frequency.toUpperCase())
                        : "* No Data Found *"
                  }
                />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col sm="6" hidden={!access.update}>
            <FormGroup>
              <Label> </Label>
              {/* <InputGroup>
                <InputGroupText>
                  <i className="icofont icofont-location-pin txt-primary"></i>
                </InputGroupText>
                <Input
                  className="bg-white text-color-light"
                  disabled
                  value={"On-site"}
                />
              </InputGroup> */}
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PositionDetails;
